import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { parseCookies, setCookie } from 'nookies';
import { useEffect, useState } from 'react';

import { NS } from '@/constants';
import { useFeature } from '@/hooks';
import { useAppSelector } from '@/redux';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { COOKIES } from '@/constants/cookies';
import { DELAY_OPEN_IOS_MODAL } from '@/constants/modal';
import { FEATURES } from '@/constants/features';

const CenteredModal = dynamic(() => import('@/components/layout/modals/CenteredModal'));
CenteredModal.displayName = 'CenteredModal';

const cookieOptions = {
  path: '/',
  maxAge: COOKIES.LEGAL_AGE.LIFETIME
};

export const LegalAgeModal = () => {
  const storeConf = useAppSelector(({ root }) => root.storeConf);
  const isPopinAgeGateFeatureEnabled = useFeature(storeConf, FEATURES.POPIN_AGE_GATE);
  const { isMobile } = useScreenSizeContext();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { t } = useTranslation(NS.COMMON);

  useEffect(() => {
    if (isPopinAgeGateFeatureEnabled) {
      // Delay to avoid IOS problem
      const timerId = setTimeout(() => {
        const legalAgeCookie = !!parseCookies()[COOKIES.LEGAL_AGE.NAME];

        if (!legalAgeCookie) {
          setModalIsOpen(true);
        }
      }, DELAY_OPEN_IOS_MODAL);
      return () => clearTimeout(timerId);
    }
  }, [isPopinAgeGateFeatureEnabled]);

  const closeModal = () => {
    setCookie({}, COOKIES.LEGAL_AGE.NAME, new Date().toString(), cookieOptions);
    setModalIsOpen(false);
  };

  return isPopinAgeGateFeatureEnabled ? (
    <CenteredModal
      opened={modalIsOpen}
      cancelAction={closeModal}
      customContent={t('legalInformations.legalAgeNotice', { age: storeConf.ageLimit })}
      fullWidth={isMobile}
      defaultFooterProps={{
        confirm: { label: t('btn.continue'), action: () => closeModal() }
      }}
    />
  ) : null;
};

export default LegalAgeModal;
